/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssayExtractionOut } from '../models/AssayExtractionOut';
import type { AssayResultPutOut } from '../models/AssayResultPutOut';
import type { ChannelExtractionOut } from '../models/ChannelExtractionOut';
import type { ExtractionPutOut } from '../models/ExtractionPutOut';
import type { ExtractionSummaryOut } from '../models/ExtractionSummaryOut';
import type { FileCreate } from '../models/FileCreate';
import type { FileMetadataIn } from '../models/FileMetadataIn';
import type { FileOut } from '../models/FileOut';
import type { FilePatch } from '../models/FilePatch';
import type { FileResourceListOut } from '../models/FileResourceListOut';
import type { FileResourceOut } from '../models/FileResourceOut';
import type { FileVersionCreate } from '../models/FileVersionCreate';
import type { FileVersionOut } from '../models/FileVersionOut';
import type { ScopeDefinitionOut } from '../models/ScopeDefinitionOut';
import type { ScopeOut } from '../models/ScopeOut';
import type { ScopeValuesIn } from '../models/ScopeValuesIn';
import type { UploadCreate } from '../models/UploadCreate';
import type { UploadOut } from '../models/UploadOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExtractionPublicationService {
    /**
     * Put Assay Result
     * @returns AssayResultPutOut Successful Response
     * @throws ApiError
     */
    public static putAssayResultV1ProjectsProjectIdAssayExtractionsFileIdPut({
        projectId,
        fileId,
        producerExecutionId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        /**
         * Stable identifier for one producer execution.
         */
        producerExecutionId: string,
        requestBody: {
            artifact_pages: Array<{
                page: number;
                payload: any;
            }>;
            data_pages: Array<{
                csv: string;
                page: number;
            }>;
            /**
             * Certificate-level metadata from the agent's extraction output.
             *
             * Mirrored from agent_service/extract/tree_schema.py::Metadata.
             */
            metadata: {
                cert?: (string | null);
                columns?: Record<string, Record<string, any>>;
                date?: (string | null);
                depth_unit?: (string | null);
                file?: (string | null);
                lab?: (string | null);
                qc_flag_codes?: Record<string, string>;
                work_order?: (string | null);
            };
            provenance_pages: Array<{
                page: number;
                payload: any;
            }>;
            status: string;
            stop_reason: string;
        },
    }): CancelablePromise<AssayResultPutOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/projects/{project_id}/assay-extractions/{file_id}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            headers: {
                'Producer-Execution-Id': producerExecutionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Producer authentication is required.`,
                403: `The producer is not authorized for this project.`,
                404: `The scoped source file was not found.`,
                409: `The source PDF changed while the result was stored.`,
                413: `The assay result exceeds 8 MiB.`,
                422: `The assay result does not satisfy the extractor contract.`,
                503: `Assay-result storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * List Extractions
     * @returns ExtractionSummaryOut Successful Response
     * @throws ApiError
     */
    public static listExtractionsV1ProjectsProjectIdExtractionsGet({
        projectId,
        kind,
        scopeId,
        limit = 50,
        offset,
    }: {
        projectId: number,
        kind: 'assay' | 'channel',
        scopeId?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<Array<ExtractionSummaryOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/extractions',
            path: {
                'project_id': projectId,
            },
            query: {
                'kind': kind,
                'scope_id': scopeId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Producer authentication is required.`,
                403: `The producer is not authorized for this project and extraction kind.`,
                404: `The scoped source file or extraction envelope was not found.`,
                409: `The source, parent, stored envelope, or schema is not current.`,
                413: `The extraction envelope exceeds 8 MiB.`,
                422: `The extraction envelope does not satisfy the producer contract.`,
                503: `Extraction-envelope storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Extraction
     * @returns any The effective native extraction envelope.
     * @throws ApiError
     */
    public static getExtractionV1ProjectsProjectIdExtractionsFileIdGet({
        projectId,
        fileId,
        kind,
        ifNoneMatch,
    }: {
        projectId: number,
        fileId: string,
        kind: 'assay' | 'channel',
        ifNoneMatch?: (string | null),
    }): CancelablePromise<(AssayExtractionOut | ChannelExtractionOut)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/extractions/{file_id}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            headers: {
                'If-None-Match': ifNoneMatch,
            },
            query: {
                'kind': kind,
            },
            errors: {
                304: `The cached extraction envelope is current.`,
                401: `Producer authentication is required.`,
                403: `The producer is not authorized for this project and extraction kind.`,
                404: `The scoped source file or extraction envelope was not found.`,
                409: `The source, parent, stored envelope, or schema is not current.`,
                413: `The extraction envelope exceeds 8 MiB.`,
                422: `The extraction envelope does not satisfy the producer contract.`,
                503: `Extraction-envelope storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Put Extraction
     * @returns ExtractionPutOut Successful Response
     * @throws ApiError
     */
    public static putExtractionV1ProjectsProjectIdExtractionsFileIdPut({
        projectId,
        fileId,
        producerExecutionId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        /**
         * Stable identifier for one producer execution.
         */
        producerExecutionId: string,
        requestBody: ({
            data: {
                artifact_pages: Array<{
                    page: number;
                    payload: any;
                }>;
                data_pages: Array<{
                    csv: string;
                    page: number;
                }>;
                /**
                 * Certificate-level metadata from the agent's extraction output.
                 *
                 * Mirrored from agent_service/extract/tree_schema.py::Metadata.
                 */
                metadata: {
                    cert?: (string | null);
                    columns?: Record<string, Record<string, any>>;
                    date?: (string | null);
                    depth_unit?: (string | null);
                    file?: (string | null);
                    lab?: (string | null);
                    qc_flag_codes?: Record<string, string>;
                    work_order?: (string | null);
                };
                provenance_pages: Array<{
                    page: number;
                    payload: any;
                }>;
            };
            kind: string;
            parents: Array<{
                effective_content_hash: string;
                file_id: string;
                kind?: string;
            }>;
            source: {
                content_hash: string;
                file_id: string;
                pdf_path: string;
            };
            status: string;
            stop_reason: string;
        } | {
            data: {
                disposition: {
                    note?: (string | null);
                    reason?: ('not_in_source' | 'not_applicable' | 'duplicate_certificate' | 'other' | null);
                    status: 'diagram_required' | 'not_required';
                };
                evidence_pages: Array<{
                    page: number;
                    payload: any;
                }>;
                tree: (({
                    card_pdf?: string;
                    cert_slug: string;
                    distance_unit?: string;
                    document_id?: string;
                    floors: Array<{
                        channels: Array<{
                            channel_id?: string;
                            chn_id: (string | number);
                            from?: string;
                            samples: Array<{
                                ag_opt?: string;
                                card_pdf?: string;
                                cu_pct?: string;
                                flag?: string;
                                frm?: string;
                                note?: string;
                                page?: string;
                                sample_id?: string;
                                sample_no: string;
                                to?: string;
                                width?: string;
                                zn_pct?: string;
                            }>;
                            to?: string;
                        }>;
                        floor?: string | null;
                        floor_id?: string;
                        floor_inferred?: boolean;
                        is_sill?: boolean;
                    }>;
                    rs?: boolean;
                    schema?: any;
                    schema_version: any;
                    synthetic?: boolean;
                    vein_abbr?: string;
                } | {
                    card_pdf?: string;
                    cert_slug: string;
                    distance_unit?: string;
                    document_id?: string;
                    floors: Array<{
                        channels: Array<{
                            channel_id: string;
                            chn_id: string;
                            from?: string;
                            samples: Array<{
                                card_pdf?: string;
                                flag?: string;
                                frm?: string;
                                note?: string;
                                page?: string;
                                sample_id: string;
                                sample_no: string;
                                to?: string;
                                width?: string;
                            }>;
                            to?: string;
                        }>;
                        floor: (string | null);
                        floor_id: string;
                    }>;
                    rs?: boolean;
                    schema?: string;
                    schema_version?: string;
                    synthetic?: boolean;
                    vein_abbr?: string;
                } | {
                    card_pdf?: string;
                    cert_slug: string;
                    distance_unit?: string;
                    document_id?: string;
                    floors: Array<{
                        channels: Array<{
                            channel_id: string;
                            chn_id: (string | number);
                            from?: string;
                            samples: Array<{
                                ag_opt?: string;
                                card_pdf?: string;
                                cu_pct?: string;
                                flag?: string;
                                frm?: string;
                                note?: string;
                                page?: string;
                                sample_id: string;
                                sample_no: string;
                                to?: string;
                                width?: string;
                                zn_pct?: string;
                            }>;
                            to?: string;
                        }>;
                        floor?: string | null;
                        floor_diagram_id: string;
                        floor_inferred?: boolean;
                        is_sill?: boolean;
                    }>;
                    rs?: boolean;
                    schema?: any;
                    schema_version: any;
                    synthetic?: boolean;
                    vein_abbr?: string;
                }) | null);
            };
            kind: string;
            parents: Array<{
                effective_content_hash: string;
                file_id: string;
                kind?: string;
            }>;
            source: {
                content_hash: string;
                file_id: string;
                pdf_path: string;
            };
            status: string;
            stop_reason: string;
        }),
    }): CancelablePromise<ExtractionPutOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/projects/{project_id}/extractions/{file_id}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            headers: {
                'Producer-Execution-Id': producerExecutionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Producer authentication is required.`,
                403: `The producer is not authorized for this project and extraction kind.`,
                404: `The scoped source file or extraction envelope was not found.`,
                409: `The source, parent, stored envelope, or schema is not current.`,
                413: `The extraction envelope exceeds 8 MiB.`,
                422: `The extraction envelope does not satisfy the producer contract.`,
                503: `Extraction-envelope storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * List Files
     * @returns any Successful Response
     * @throws ApiError
     */
    public static listFilesV1ProjectsProjectIdFilesGet({
        projectId,
        scopeId,
        q,
        externalKey,
        sourceOnly = false,
        includeTotal = false,
        limit = 100,
        offset,
    }: {
        projectId: number,
        scopeId?: (string | null),
        q?: (string | null),
        externalKey?: (string | null),
        sourceOnly?: boolean,
        includeTotal?: boolean,
        limit?: number,
        offset?: number,
    }): CancelablePromise<(Array<FileResourceOut> | FileResourceListOut)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/files',
            path: {
                'project_id': projectId,
            },
            query: {
                'scope_id': scopeId,
                'q': q,
                'external_key': externalKey,
                'source_only': sourceOnly,
                'include_total': includeTotal,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The file, version, or scope was not found.`,
                409: `The source content or lineage is not currently available.`,
                422: `Validation Error`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Create File
     * @returns FileOut Successful Response
     * @throws ApiError
     */
    public static createFileV1ProjectsProjectIdFilesPost({
        projectId,
        idempotencyKey,
        requestBody,
    }: {
        projectId: number,
        idempotencyKey: string,
        requestBody: FileCreate,
    }): CancelablePromise<FileOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{project_id}/files',
            path: {
                'project_id': projectId,
            },
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Producer authentication is required.`,
                403: `The producer is not authorized for this project.`,
                404: `The project, scope, file, or committed blob was not found.`,
                409: `The file identity, version head, or committed blob is not publishable.`,
                422: `The source-file publication request is invalid.`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get File
     * @returns FileResourceOut Successful Response
     * @throws ApiError
     */
    public static getFileV1ProjectsProjectIdFilesFileIdGet({
        projectId,
        fileId,
    }: {
        projectId: number,
        fileId: string,
    }): CancelablePromise<FileResourceOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/files/{file_id}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The file, version, or scope was not found.`,
                409: `The source content or lineage is not currently available.`,
                422: `Validation Error`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Patch File
     * @returns FileResourceOut Successful Response
     * @throws ApiError
     */
    public static patchFileV1ProjectsProjectIdFilesFileIdPatch({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: FilePatch,
    }): CancelablePromise<FileResourceOut> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/projects/{project_id}/files/{file_id}',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The file, version, or scope was not found.`,
                409: `The source content or lineage is not currently available.`,
                422: `The attribute patch or resulting metadata is invalid.`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get File Content
     * @returns binary Source PDF.
     * @throws ApiError
     */
    public static getFileContentV1ProjectsProjectIdFilesFileIdContentGet({
        projectId,
        fileId,
        range,
    }: {
        projectId: number,
        fileId: string,
        range?: (string | null),
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/files/{file_id}/content',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            headers: {
                'Range': range,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The file, version, or scope was not found.`,
                409: `The source content or lineage is not currently available.`,
                416: `Invalid or unsatisfiable byte range.`,
                422: `Validation Error`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Post File Metadata
     * @returns FileResourceOut Successful Response
     * @throws ApiError
     */
    public static postFileMetadataV1ProjectsProjectIdFilesFileIdMetadataPost({
        projectId,
        fileId,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        requestBody: FileMetadataIn,
    }): CancelablePromise<FileResourceOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{project_id}/files/{file_id}/metadata',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The file was not found.`,
                422: `The attribute changes or resulting metadata is invalid.`,
            },
        });
    }
    /**
     * List File Versions
     * @returns FileVersionOut Successful Response
     * @throws ApiError
     */
    public static listFileVersionsV1ProjectsProjectIdFilesFileIdVersionsGet({
        projectId,
        fileId,
        sha256,
        limit = 100,
        offset,
    }: {
        projectId: number,
        fileId: string,
        sha256?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<Array<FileVersionOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/files/{file_id}/versions',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            query: {
                'sha256': sha256,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The file, version, or scope was not found.`,
                409: `The source content or lineage is not currently available.`,
                422: `Validation Error`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Create File Version
     * @returns FileVersionOut Successful Response
     * @throws ApiError
     */
    public static createFileVersionV1ProjectsProjectIdFilesFileIdVersionsPost({
        projectId,
        fileId,
        idempotencyKey,
        requestBody,
    }: {
        projectId: number,
        fileId: string,
        idempotencyKey: string,
        requestBody: FileVersionCreate,
    }): CancelablePromise<FileVersionOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{project_id}/files/{file_id}/versions',
            path: {
                'project_id': projectId,
                'file_id': fileId,
            },
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Producer authentication is required.`,
                403: `The producer is not authorized for this project.`,
                404: `The project, scope, file, or committed blob was not found.`,
                409: `The file identity, version head, or committed blob is not publishable.`,
                415: `The committed blob media type is not application/pdf.`,
                422: `The source-file publication request is invalid.`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get File Version Content
     * @returns binary Source PDF.
     * @throws ApiError
     */
    public static getFileVersionContentV1ProjectsProjectIdFilesFileIdVersionsVersionIdContentGet({
        projectId,
        fileId,
        versionId,
        range,
    }: {
        projectId: number,
        fileId: string,
        versionId: string,
        range?: (string | null),
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/files/{file_id}/versions/{version_id}/content',
            path: {
                'project_id': projectId,
                'file_id': fileId,
                'version_id': versionId,
            },
            headers: {
                'Range': range,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The file, version, or scope was not found.`,
                409: `The source content or lineage is not currently available.`,
                416: `Invalid or unsatisfiable byte range.`,
                422: `Validation Error`,
                503: `Source-file storage is temporarily unavailable.`,
            },
        });
    }
    /**
     * Get Producer Scope Definition
     * @returns ScopeDefinitionOut Successful Response
     * @throws ApiError
     */
    public static getProducerScopeDefinitionV1ProjectsProjectIdScopeDefinitionGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<ScopeDefinitionOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/scope-definition',
            path: {
                'project_id': projectId,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The project or scope was not found.`,
                422: `The scope request is invalid.`,
            },
        });
    }
    /**
     * List Project Scopes
     * @returns ScopeOut Successful Response
     * @throws ApiError
     */
    public static listProjectScopesV1ProjectsProjectIdScopesGet({
        projectId,
    }: {
        projectId: number,
    }): CancelablePromise<Array<ScopeOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/scopes',
            path: {
                'project_id': projectId,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The project or scope was not found.`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Producer Scope
     * @returns ScopeOut Successful Response
     * @throws ApiError
     */
    public static getProducerScopeV1ProjectsProjectIdScopesScopeIdGet({
        projectId,
        scopeId,
    }: {
        projectId: number,
        scopeId: string,
    }): CancelablePromise<ScopeOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/scopes/{scope_id}',
            path: {
                'project_id': projectId,
                'scope_id': scopeId,
            },
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The project or scope was not found.`,
                422: `The scope request is invalid.`,
            },
        });
    }
    /**
     * Resolve Producer Scope
     * @returns ScopeOut Successful Response
     * @throws ApiError
     */
    public static resolveProducerScopeV1ProjectsProjectIdScopesResolvePut({
        projectId,
        requestBody,
    }: {
        projectId: number,
        requestBody: ScopeValuesIn,
    }): CancelablePromise<ScopeOut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/projects/{project_id}/scopes:resolve',
            path: {
                'project_id': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Authentication is required.`,
                403: `The caller is not authorized for this project.`,
                404: `The project or scope was not found.`,
                422: `The scope request is invalid.`,
            },
        });
    }
    /**
     * Prepare Upload
     * @returns UploadOut Successful Response
     * @throws ApiError
     */
    public static prepareUploadV1ProjectsProjectIdUploadsPost({
        projectId,
        idempotencyKey,
        requestBody,
    }: {
        projectId: number,
        idempotencyKey: string,
        requestBody: UploadCreate,
    }): CancelablePromise<UploadOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{project_id}/uploads',
            path: {
                'project_id': projectId,
            },
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                410: `project_archived: workbook and workbook_manifest uploads are unavailable for archived projects.`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Upload
     * @returns UploadOut Successful Response
     * @throws ApiError
     */
    public static getUploadV1ProjectsProjectIdUploadsUploadIdGet({
        projectId,
        uploadId,
    }: {
        projectId: number,
        uploadId: string,
    }): CancelablePromise<UploadOut> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/projects/{project_id}/uploads/{upload_id}',
            path: {
                'project_id': projectId,
                'upload_id': uploadId,
            },
            errors: {
                410: `project_archived: workbook and workbook_manifest uploads are unavailable for archived projects.`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Commit Upload
     * @returns UploadOut Successful Response
     * @throws ApiError
     */
    public static commitUploadV1ProjectsProjectIdUploadsUploadIdCommitPost({
        projectId,
        uploadId,
        idempotencyKey,
    }: {
        projectId: number,
        uploadId: string,
        idempotencyKey: string,
    }): CancelablePromise<UploadOut> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/projects/{project_id}/uploads/{upload_id}:commit',
            path: {
                'project_id': projectId,
                'upload_id': uploadId,
            },
            headers: {
                'Idempotency-Key': idempotencyKey,
            },
            errors: {
                410: `project_archived: workbook and workbook_manifest uploads are unavailable for archived projects.`,
                422: `Validation Error`,
            },
        });
    }
}
